module.exports = __webpack_public_path__ + "static/img/file_rust.0611f0b3.png";